import React, {useCallback, useEffect, useState} from 'react';
import {COLORS, SIZES, Typography} from '@fupa/fupa-uikit';
import styled from 'styled-components';
import {useSelector} from 'react-redux';
import {selectCollapsedAppBar} from 'app/hooks/reduxCreateSelectorHooks';
import {desktopContentWidth} from 'app/styles/media';

const COLLAPSED_HEIGHT = 42;
const EXPANDED_HEIGHT = 114;

const TitleContainer = styled.div`
  position: ${props => (props.sticky ? 'fixed' : 'relative')};
  top: ${props =>
    props.sticky ? (props.collapsed ? COLLAPSED_HEIGHT.toString() + 'px' : EXPANDED_HEIGHT.toString() + 'px') : '0'};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${SIZES[8]};
  width: 100%;
  background-color: ${COLORS.lighterGrey};
  transition: top 0.3s;
  z-index: 1;
  max-width: ${props => props.theme.desktopContentWidth}px;
  ${props => props.theme.desktopLayout`
    top: ${props => (props.sticky ? EXPANDED_HEIGHT.toString() + 'px' : '0')};
  `};
`;

const CustomSubheading = styled(Typography)`
  &&& {
    margin: 0;
    line-height: ${SIZES[24]};
  }
`;

export const StickyHeader = ({title}) => {
  const [sticky, setSticky] = useState(false);
  const [stickyTitle, setStickyTitle] = useState(null);
  const collapsedAppBar = useSelector(selectCollapsedAppBar);

  const stickyRef = useCallback(node => {
    if (node !== null) {
      setStickyTitle(node);
    }
  }, []);

  useEffect(() => {
    const onScroll = () => {
      // threshold is either only TabBar (collapsed AppBar) or TabBar+AppBar (not collapsed)
      const threshold = collapsedAppBar && window.innerWidth < desktopContentWidth ? COLLAPSED_HEIGHT : EXPANDED_HEIGHT;
      const headerY = stickyTitle.getBoundingClientRect().top;
      if (headerY <= threshold) {
        setSticky(true);
      } else if (headerY > threshold) {
        setSticky(false);
      }
    };

    window.addEventListener('scroll', onScroll, {passive: true});
    return () => {
      window.removeEventListener('scroll', onScroll, {passive: true});
    };
  }, [stickyTitle, collapsedAppBar]);

  // Add another component to avoid changing page height by removing component from relative-dom
  const stickyContainer = sticky ? (
    <TitleContainer sticky={true} collapsed={collapsedAppBar}>
      <CustomSubheading variant='subheading2'>{title}</CustomSubheading>
    </TitleContainer>
  ) : null;

  return (
    <>
      <TitleContainer ref={stickyRef} sticky={false}>
        <CustomSubheading variant='subheading2'>{title}</CustomSubheading>
      </TitleContainer>
      {stickyContainer}
    </>
  );
};
